/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteProgramInput = {
    programId: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteProgramMutationVariables = {
    input: DeleteProgramInput;
};
export type deleteProgramMutationResponse = {
    readonly deleteProgram: {
        readonly deletedProgramId: string | null;
    } | null;
};
export type deleteProgramMutation = {
    readonly response: deleteProgramMutationResponse;
    readonly variables: deleteProgramMutationVariables;
};



/*
mutation deleteProgramMutation(
  $input: DeleteProgramInput!
) {
  deleteProgram(input: $input) {
    deletedProgramId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteProgramInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProgramPayload",
    "kind": "LinkedField",
    "name": "deleteProgram",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedProgramId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteProgramMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteProgramMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteProgramMutation",
    "operationKind": "mutation",
    "text": "mutation deleteProgramMutation(\n  $input: DeleteProgramInput!\n) {\n  deleteProgram(input: $input) {\n    deletedProgramId\n  }\n}\n"
  }
};
})();
(node as any).hash = '51fa0264de5595bcc693195e94beca72';
export default node;
